import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import * as selectorsDocumentos from '../../../store/documento/reducer';
import * as actionsDocumentos from '../../../store/documento/actions';
import { DialogDefaultV2, InputV2, DefaultSelectV2, TrueFalseSelectV2, DropzoneV2 } from '../../../components/v2';

const schema = {
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  modulo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  ativo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  arquivo: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const moduloOptions = [
  { id: 'NSIR', nome: 'Nsir' },
  { id: 'FINANCEIRO', nome: 'Financeiro' },
  { id: 'USUARIO', nome: 'Usuário' },
];

const Formulario = ({ saveDocumento, selectedDocumento, open, id, onClose, findDocumentoById }) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [arquivo, setArquivo] = useState(null);

  useEffect(() => {
    if (id) findDocumentoById(id);
  }, [id, findDocumentoById]);

  useEffect(() => {
    if (id && selectedDocumento) {
      setValues(selectedDocumento);
      setArquivo(selectedDocumento.arquivoFile);
    }
  }, [id, selectedDocumento]);

  const onSave = () => {
    const erros = validate({ ...values, arquivo }, schema);
    setErrors(erros);
    if (!erros) {
      const payload = {
        ...values,
        arquivo: {
          nome: values.arquivoFile.name.split('.')[0],
          extensao: values.arquivoFile.name.split('.').pop(),
          status: 'NOT_SYNC',
        },
      };
      saveDocumento(payload, saveCallback);
    }
  };

  const saveCallback = success => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({});
    setArquivo(null);
    onClose(isSave);
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Documento"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.nome)}
            isRequired
            label="Nome"
            name="nome"
            onChange={handleChange}
            value={values.nome || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <DefaultSelectV2
            error={!!(errors && errors.modulo)}
            isRequired
            label="Módulo"
            name="modulo"
            showEmpty
            options={moduloOptions}
            onSelect={handleChange}
            value={values.modulo}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }} sx={{ pb: 0 }}>
          <TrueFalseSelectV2
            error={!!(errors && errors.ativo)}
            isRequired
            label="Ativo"
            name="ativo"
            onChange={handleChange}
            value={values.ativo}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            label="Descrição"
            name="descricao"
            onChange={handleChange}
            value={values.descricao || ''}
            rows={3}
            multiline
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }} sx={{ pb: 0 }}>
          <DropzoneV2
            buttonText="Arquivo"
            filesLimit={1}
            acceptedFiles={['.pdf']}
            error={!!(errors && errors.arquivo)}
            onSave={files => {
              if (files != null && files.length > 0) {
                const file = files[0];
                setArquivo(file);
                setValues(prev => ({ ...prev, arquivoFile: file }));
              }
            }}
            canDeleteFiles
            showGridFiles
            files={arquivo != null ? [{
              file: arquivo,
              nome: arquivo.name,
              onDelete: () => {
                setArquivo(null);
                setValues(prev => ({ ...prev, arquivoFile: null }));
              },
            }] : []}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  saveDocumento: PropTypes.func.isRequired,
  findDocumentoById: PropTypes.func.isRequired,
  selectedDocumento: PropTypes.object,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selectedDocumento: selectorsDocumentos.getSelectedDocument(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsDocumentos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
